const actions = {
  FETCH_ACTIVITYLOGS: 'activityLogs/FETCH',
  ACTIVITYLOGS_RECEIVED: 'activityLogs/RECEIVED',
  REQUESTING: 'activityLogs/REQUESTING',
}

export default actions
